import React from "react";
import { useTranslation } from "react-i18next";
import { Props } from "./types";
import styles from "./styles.scss";

function Switch(props: Props) {
  const { t } = useTranslation();

  return (
    <div
      className={styles.switch}
      onClick={(e) => {
        e.stopPropagation();
        props.switch();
      }}
    >
      <div className={styles.button}>
        <p className={styles.paragraph}>
          + {t("statusCreationForm.addStatus")}
        </p>
      </div>
    </div>
  );
}

export { Switch };
